import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminIssueReasonList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            {
              key: "issueCategoryId",
              name: "Issue Category",
              type: "issueCategory",
              filter: true,
              width: 200,
            },
            { key: "name", name: "Name", type: "string" },
          ]}
          sort={[
            {
              key: "issueCategoryId",
              direction: "ascending",
              type: "issueCategory",
            },
            {
              key: "name",
              direction: "ascending",
            },
          ]}
          rows={Object.values(this.context.issueReasonsIndexed)}
          onClick={(issueReason) => {
            this.props.history.push({
              pathname: "/admin/issueReason/" + issueReason.id,
            });
          }}
        />
      );
    }
  },
);
